import {ConnectionCloseInfo, EventDetails, WampDict, WampList} from '@verkehrsministerium/kraftfahrstrasse';

export enum Status {
  Unknown,
  Connecting,
  Connected,
  Disconnecting,
  Disconnected,
  Error,
}

export type MessageReceivedCallback = (args: WampList, kwArgs: WampDict, details: EventDetails) => any;

export type OnDisconnectedHandler = (closeInfo: ConnectionCloseInfo) => Promise<void>;
